
export default {
  data() {
    return {
      options: [
        {
          name: "question",
          label: "Question",
          type: "text",
        },
        {
          name: "answer",
          label: "Answer",
          type: "tipTap",
        },
      ],
    };
  },
  mounted() {
    // console.log(this.$auth.loggedin);
    // if (!this.$auth.loggedin) {
    //   let url = "/faq";
    //   if (this.$i18n.locale === "hr") {
    //     url = "/hr/faq";
    //   }
    //   this.$router.push(url);
    // }
  },
};
